import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import { Pencil} from 'lucide-react';

import * as Actions from '../../../../Reducers/actions'
import { useNavigate } from 'react-router-dom';

function EditListsButton(props) {
    const navigate = useNavigate();

    return (
        <div>
            <IconButton onClick={() => navigate(`/modifydropdown/${props.uniqueId}`)} size='large' style={{ borderRadius: 0 }}>
                <Pencil fontSize="inherit" />
            </IconButton>
        </div>
    )
}

const mapStateToProps = state => ({
    lists: state.lists,
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
})

export default compose(connect(
    mapStateToProps,
    mapDispatchToProps
))(EditListsButton);